import type { Tokens } from '@core-frontend/core-frontend';

import type { LoginRequest } from '@/widgets/auth/Login/models';

import { baseClient } from '@/shared/api/baseClient';
import { X_HOST_HEADER_KEY } from '@/shared/api/constants';
import { env } from '@/shared/lib/env';

export const loginAsync = async (
  body: LoginRequest,
  inCore?: boolean
): Promise<Tokens> => {
  const response = await baseClient.post('/auth/signin', body, {
    headers: !inCore
      ? {
          [X_HOST_HEADER_KEY]: `${env.VITE_APP_TENANT}.${env.VITE_API_DOMAIN}`,
        }
      : {},
  });
  return response.data;
};
